import type { AppointmentsFeatureConfig } from './type';

export const appointments: AppointmentsFeatureConfig = {
    fetchHomeBranchById: false,
    invalidateCacheAfterCancelingAppointment: false,
    showHomeBranch: true,
    filterBranchesBasedOnSelectedChannel: false,
    timeslotsIntervalInDays: 60,
    videoAppointmentInNewTab: true,
    maxDescriptionLength: 1500,
    showDataProcessingLegalDisclaimer: false,
};
